const ns = 'c-mapbox-map';

class Icons {
    static cluster(layer, name, type, dim = [30, 30]) {
        const classNames = [
            `${ns}__cluster`,
            `${ns}__cluster--${name}`,
            `${ns}__cluster--${type}`,
        ];
        return new L.DivIcon({
            className: classNames.join(' '),
            html: `<div class="inner"><p>${layer.getChildCount()}</p></div>`,
            iconSize: Icons.point(dim),
        });
    }

    static marker(name, type, id, dim = [20, 20]) {
        const classNames = [
            `${ns}__marker`,
            `${ns}__marker--${name}`,
            `${ns}__marker--${type}`,
            `${ns}__marker--${id}`,
        ];
        return new L.DivIcon({
            className: classNames.join(' '),
            html: '<div class="inner"></div>',
            iconSize: Icons.point(dim),
        });
    }

    static point(dim) {
        const [w, h] = dim;
        return new L.Point(w, h);
    }
}

export default class Group {
    constructor(name, type = name, clustering = false, property = 'type') {
        this.name = name;
        this.type = type;
        this.clustering = clustering;
        this.property = property;

        this._layer = clustering ? L.markerClusterGroup({
            maxClusterRadius: 40,
            showCoverageOnHover: false,
            spiderfyOnMaxZoom: false,
            iconCreateFunction: layer => Icons.cluster(layer, this.name.toLowerCase(), this.type.toLowerCase()),
        }) : L.featureGroup();
    }

    getLayer() {
        return this._layer;
    }

    isMatch(marker) {
        const markerVal = marker.feature.properties[this.property];
        let t = this.type;
        try {
            t = JSON.parse(this.type);
        } catch (e) {}
        return t === markerVal;
    }

    addMarker(marker) {
        marker.setIcon(Icons.marker(this.name.toLowerCase(), this.type.toLowerCase(), marker.feature.properties.id));
        this._layer.addLayer(marker);
    }
}


// WEBPACK FOOTER //
// ./Assets/Scripts/Components/Mapbox/group/_group.js